




































































































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { CreateActionModel } from '@/components/form/CreateActionForm.vue'
import { ActionType, ReferralStatus } from '@/api/types'
import { ActionAPI, OrderAPI, ReferralAPI } from '@/api/backend-client'
import { Action } from '@/api/model/action'
import { v4 as uuid } from 'uuid'
import { namespace } from 'vuex-class'
import { Order } from '@/api/model/order'
import { escapeHtml } from '@/helpers/html'
const referrals = namespace('referrals')

@Component
export default class DetailHeader extends Vue {
    @referrals.State readonly view!: string
    @referrals.State readonly direction!: string
    @referrals.Action applyView: ({ view: ReferralView, direction: ReferralFilterDirection }) => Promise<void>
    @Inject() reloadReferral: () => Promise<void>
    @Prop({ required: true }) readonly referral!: Referral
    modalCreateAction: boolean = false
    submittingCreateAction: boolean = false
    formCreateAction: CreateActionModel = { notify: false, actionDate: null, type: ActionType.MEETING }
    reopenTaskModalVisible: boolean = false
    transferReferralModalVisible: boolean = false
    createAdditionalReferralModalVisible: boolean = false
    createOrderModalVisible: boolean = false
    quickActionsVisible: boolean = false
    orders: Order[] = []

    async mounted() {
        await this.fetchOrders()
    }

    toggleQuickActions(): void {
        this.quickActionsVisible = !this.quickActionsVisible
    }

    generateReferralStatusClasses(status: string) {
        const classes = {
            'new': 'active',
            'appointment': 'active',
            'proposal': 'active',
            'on-hold': 'pending',
            'pending': 'pending',
            'unreachable': 'hold',
            'successful': 'closed',
            'processed': 'closed',
            'closed': 'closed',
        }

        return classes[status]
    }

    async deleteReferral(): Promise<void> {
        if (confirm(this.$t('referral.deleteMessage').toString())) {
            try {
                await this.fetchOrders()
                if (this.hasOrders) {
                    this.$notify({
                        type: 'error',
                        title: 'Foutmelding',
                        text: 'Er bestaat voor deze lead al een opdracht',
                    })
                    return
                }

                await ReferralAPI.delete(this.referral.id)
                this.$notify({
                    type: 'success',
                    text: this.$t('referral.deleteSuccess').toString(),
                })

                // Reload referral list and navigate back to lister.
                await this.applyView({ view: this.view, direction: this.direction })
                await this.$router.push({name: 'tasks_all'})

            } catch (error) {
                this.$notify({
                    type: 'error',
                    title: 'Foutmelding',
                    text: escapeHtml(error.message),
                })
            }
        }
    }

    async fetchOrders(): Promise<void> {
        this.orders = await OrderAPI.getAll({
            referral: this.referral.id,
        })
    }

    get hasOrders(): boolean {
        return this.orders.length > 0
    }

    get canDeleteReferral(): boolean {
        return this.$currentUser.isCompanyManager && !this.hasOrders
    }

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.referral || !this.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.referral.assignedToBranch.company.id
    }

    get canCreateOrder(): boolean {
        if (!this.$currentCompany.orderSettings) {
            return false
        }

        return this.$currentCompany.orderSettings.enabled &&
            this.$currentCompany.orderSettings.allowManualCreation &&
            this.referral.status === ReferralStatus.SUCCESSFUL
    }

    get isEditable(): boolean {
        if (!this.referral || ['processed', 'closed'].includes(this.referral.status)) {
            return false
        }

        return true
    }

    get canReopen(): boolean {
        if (!this.canEdit) {
            return false
        }

        if (this.referral.status === 'processed') {
            return true
        } else if (this.referral.status === 'closed') {
            return this.$currentUser.isTeamLead
        }

        return false
    }

    get shouldShowLinkExternalProjectModal() {

        // Source company must be different from target company.
        return this.referral.referredByBranch.company.id !== this.referral.assignedToBranch.company.id

            // Assigned to branch must belong to our current company.
            && this.referral.assignedToBranch.company.id === this.$currentCompany.id

            // Source company must have set a project.
            && this.referral.project

            // Current company must not yet have selected a project.
            && this.referral.assigneeProject === null
    }

    async createAction(): Promise<void> {
        this.submittingCreateAction = true

        const statusses = [
            ReferralStatus.NEW,
            ReferralStatus.PENDING,
            ReferralStatus.UNREACHABLE,
        ]

        // If one of above status
        if (statusses.includes(this.referral.status)) {

            // Ask if we should update referral status also.
            if (confirm(this.$t('edit-task-modal.change-status-to-appointment').toString())) {

                await ReferralAPI.update(this.referral.id, {
                    ...this.referral,
                    status: ReferralStatus.APPOINTMENT,
                    statusReason: null,
                } as Referral)
            }
        }

        // api
        await ActionAPI.create({
            ...Action.fromData({
                referral: this.referral,
                type: this.formCreateAction.type,
                appointmentType: this.formCreateAction.appointmentType,
                actionDate: this.formCreateAction.actionDate,
                assignedTo: this.formCreateAction.assignedTo,
                comment: this.formCreateAction.comment,
                id: uuid(),
                createdBy: this.$currentUser.resourceIdentifier,
            }),

            // @todo: not actually part of the model, should be a seperate call
            // @ts-ignore
            informAssignedTo: this.formCreateAction.notify,
        })

        await this.reloadReferral()
        this.submittingCreateAction = false
        this.modalCreateAction = false
    }

    get isAssigned(): boolean {
        return this.referral.assignedTo !== null
    }
}
